import { apiClient, ApiError } from '@shoots/auth'

export type ResendResult =
  /** The request was accepted. Says NOTHING about whether a number matched an
   * organizer — the server answers identically either way (no enumeration), so
   * the UI must not claim a text was sent to *you*. */
  | { status: 'accepted' }
  /** The input was not a phone number. The only failure the server distinguishes,
   * because it is about what was typed, not about who has an account. */
  | { status: 'invalid_phone' }
  | { status: 'error' }

export class PaymentSetupService {
  /**
   * Ask Shoots to re-text the payment-setup link (issue #209). Public endpoint —
   * the organizer is on the error page with a broken link and no session.
   */
  async resendLink(phoneNumber: string): Promise<ResendResult> {
    try {
      await apiClient.post('/functions/v1/payment-setup-recover', {
        phone_number: phoneNumber,
      })
      return { status: 'accepted' }
    } catch (error) {
      if (error instanceof ApiError && error.status === 400) {
        return { status: 'invalid_phone' }
      }
      console.error('Failed to request a fresh payment setup link:', error)
      return { status: 'error' }
    }
  }
}

export const paymentSetupService = new PaymentSetupService()
